import { CookingPot, Flame, Leaf } from "lucide-react";

const panels = [
  {
    icon: CookingPot,
    title: "Diungkep bumbu kuning",
    text: "Ayam pejantan direbus perlahan dalam bumbu ungkep kuning sampai gurihnya meresap ke serat daging paling dalam.",
  },
  {
    icon: Flame,
    title: "Digoreng sebentar saja",
    text: "Bukan kering krispi — ayam digoreng sebentar supaya teksturnya tetap juicy dan 'basah' bumbu, persis ayam goreng khas Bandung.",
  },
  {
    icon: Leaf,
    title: "Jukut goreng gurih",
    text: "Sayuran yang digoreng gurih dan renyah — pendamping wajib yang bikin seporsi ayam basah makin susah berhenti.",
  },
];

export const WhyBasah = () => (
  <section data-testid="why-basah-section" className="mx-auto max-w-6xl px-5 py-16 sm:py-24">
    <div className="max-w-2xl">
      <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu">
        Rahasianya
      </p>
      <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-charcoal sm:text-4xl">
        Kenapa yang <span className="italic text-bumbu">basah</span> justru bikin nagih?
      </h2>
    </div>

    <div className="mt-12 grid gap-6 lg:grid-cols-3">
      <div className="grid gap-6 sm:grid-cols-3 lg:col-span-2 lg:grid-cols-1 xl:grid-cols-1">
        {panels.map((p, i) => (
          <div
            key={p.title}
            className="flex gap-5 rounded-lg border border-amber-900/15 bg-white p-6 transition-transform duration-200 hover:-translate-y-1 sm:p-7"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-bumbu-light text-bumbu-deep">
              <p.icon className="h-6 w-6" aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-heading text-lg font-bold text-charcoal">
                <span className="mr-2 font-mono text-xs font-bold text-bumbu">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-charcoal-muted">{p.text}</p>
            </div>
          </div>
        ))}
      </div>

      <figure className="relative overflow-hidden rounded-lg border border-amber-900/15 lg:row-span-1">
        <img
          src="/images/sides.webp"
          alt="Lauk goreng keemasan pendamping ayam goreng basah"
          width="1200"
          height="1800"
          loading="lazy"
          className="h-full min-h-[320px] w-full object-cover"
        />
        <figcaption className="absolute inset-x-0 bottom-0 bg-charcoal/85 px-5 py-3 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-bumbu-bright">
          Digoreng saat dipesan
        </figcaption>
      </figure>
    </div>
  </section>
);
